import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import {
deleteVideosAction,
deleteVideosrelatedAction,
readLanguageAction,
readVideosAction,
saveCommonsUrlsAction,
saveDownloadVideoUrlLanguageAction,
saveVideoLanguageAction,
saveVideoPreviewLanguageAction,
saveVideoPreviewUrlsAction,
saveVideoUrlLanguageAction,
saveVideosAction,
saveVideosDownloadUrlsAction,
saveVideosThumbNailUrlsAction,
saveVideosUrlsAction,
saveVideosrelatedAction,
translateLanguageAction,
updateCommonsUrlsAction,
updateDownloadVideoUrlLanguageAction,
updateVideoLanguageAction,
updateVideoPreviewLanguageAction,
updateVideoPreviewUrlsAction,
updateVideoUrlLanguageAction,
updateVideosAction,
updateVideosDownloadUrlsAction,
updateVideosThumbNailUrlsAction,
updateVideosUrlsAction,
uploadAssestsAction,
uploadAssestsV2Action,
uploadVideosV2Action,
} from "../../../store/Languages/LanguageAction";
import Toastiy from "../../../components/universal/Toastiy";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
deleteVideoLayoutAction,
readVideoLayoutAction,
saveVideoLayoutAction,
updateVideoLayoutAction,
} from "../../../store/Layout/LayoutAction";
import { setShowNavigationAlertAction } from "../../../store/GlobalLoader/GlobalLoaderAction";
import { sendCustomNotificationAction } from "../../../store/Notifications/NotificationAction";
import { fetchChurchesRequest } from "../../../store/Churches/actions";
import {saveResourceVideoRequest} from "../../../store/ResouceVideo/ResourceVideosActions"
import {saveResourceRequest,updateResourceRequest,deleteResourceRequest} from '../../../store/Resources/actions'
const ChurchHooks = () => {
const [value, setValue] = useState("");
const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};

return { value, onChangeSearchBar };
};

export default ChurchHooks;

export const AllChurchHooks = () => {
const dispatch = useDispatch();

const [value, setValue] = useState("");
const [reloadData, setReloadData] = useState(false);
const fetchAllChurches = (
    page,
    limit,
    searchCriteria = {},
    callbackFn,
    churchId = ""
  ) => {

    dispatch(
      fetchChurchesRequest({
        apiPayloadRequest: {
          page: page,
          limit: limit,
          searchCriteria: searchCriteria,
          _id: churchId,
        },
        callback: (Data) => {
          if (Data?.type === 1) {
            // 🔹 Flatten resources from each church
            let allResources = (Data?.data ?? []).flatMap((church) =>
              (church.resources ?? []).map((resource) => ({
                ...resource,
                churchId: church._id, // attach church id
              }))
            );

            // ✅ Filter by selected churchId if provided
            if (churchId) {
              allResources = allResources.filter(
                (resource) => resource.churchId === churchId
              );
            }

            if (callbackFn) {
              callbackFn({
                data: allResources,
                total: allResources.length, // or use Data?.totalRecords if available
              });
            }
          } else if (callbackFn) {
            callbackFn({ data: [], total: 0 });
          }
        },
      })
    );
  };







const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};


const handleDelete = (row) => {
        return new Promise((resolve, reject) => {
      dispatch(
        deleteResourceRequest({
          _id: row.churchId,               // ✅ church id
          resourceObjId: row.resourceObjId, // ✅ resource id
          callback: (res) => {
            if (res.type === 1) {
              toast.success("Resource deleted successfully ");
              resolve(res); // resolves the promise on success
            } else {
              toast.error("Delete failed: " + res.error);
              reject(res);  // rejects the promise on failure
            }
          },
        })
      );
    });
  };




const getVideoDeletedResponse = (data, message) => {
    if (data?.type === 1) {
    Toastiy(message, data?.type);
    } else {
    Toastiy("Issue performing the operation, contact admin!!", data?.type);
    }
};
return {
    value,
    onChangeSearchBar,
    handleDelete,
    reloadData,
    setReloadData,
    fetchAllChurches
};
};

export const AddChurchHooks = (setLoading, data) => {
// search logic here
const [options, setOptions] = useState([]);
const [value, setValue] = useState("");
const [activeTab, setActiveTab] = useState("en");
const [activeLanguageDetails, setActiveLanguageDetails] = useState({
    language_code: "en",
    language_name: "English",
});
const [allLanguageData, setAllLanguageData] = useState([]);
const [readLanguageData, setReadLanguageData] = useState([]);
const [selectedOptions, setSelectedOptions] = useState([]);
const [selectedRelatedVideoIndex, setSelectedRelatedVideoIndex] = useState(null);
const [relatedVideos, setRelatedVideos] = useState([]);
const [thumbnailImage, setThumbnailImage] = useState(null);
const [isLive,setIslive] =useState(false)
const [isDefault,setIsDefault] =useState(false)
const dispatch = useDispatch();

const onChangeSearchBar = (e) => {
    setValue(e.target.value);
};
// add category logic here

const initialLayoutValues = {
    _id: "",
    mobile_layout: "1",
    layout_name: "",
    order: "",
    // title: "",
    // subtitle: "",
    // expiry: "",
};

const initialVideoValues = {
    video_title: "",
    video_description: "",
    _id: "",
};

const [layoutValues, setLayoutValues] = useState(initialLayoutValues);
const [addedLayout, setAddedLayout] = useState(false);

const initialStateValues = {
    mobileUploadUrl: "",
    webUploadUrl: "",
    tabletUploadUrl: "",
};

const languages = [
    "English",
    "hindi",
    "tamil",
    "telugu",
    "Malayalam",
    "Spanish",
    "Marathi",
    "Urdu",
    "Oriya",
    "kanada",
    "Bengali",
]; // List of languages

const [downloadValues, setDownloadValues] = useState("");
const [downloadUrl, setDownloadUrl] = useState("");
const [thumbNailValues, setThumbNailValues] = useState("");
const [thumbNailUrl, setThumbNailUrl] = useState("");
const [inputs, setInputs] = useState("");
const [showVideoLibraryModal, setShowVideoLibraryModal] = useState(false);
const [videoInputs, setVideoInputs] = useState(initialVideoValues);
const [videoErrors, setVideoErrors] = useState({
    video_title: false,
    video_description: false,
    video_urls: false,
    video_download_urls: false,
    video_thumbnails_urls: false,
    video_common_thumbnails_urls: false,
    video_preview_urls: false,
    selectedOptions: false,
});

const [currentInputs, setCurrentInputs] = useState();
const [languagemeta, setLanguagemeta] = useState();

const [videoUrlsInputs, setVideoUrlsInputs] = useState(initialStateValues);
const [UdownloadrlsInputs, setDownloadUrlsInputs] = useState(initialStateValues);
const [tumbNailUrlsInputs, setTumbNailUrlsInputs] = useState(initialStateValues);
const [commonVideoUrlsInputs, setCommonUrlsInputs] = useState(initialStateValues);
const [previewUrlsInputs, setPreviewUrlsInputs] = useState(initialStateValues);
const [ImageSet,setImageSet]=useState();
const [videoUrlsInputsCheck, setVideoUrlsInputsCheck] = useState();
const [UdownloadrlsInputsCheck, setDownloadUrlsInputsCheck] = useState();
const [tumbNailUrlsInputsCheck, setTumbNailUrlsInputsCheck] = useState();
const [commonUrlsInputsCheck, setCommonUrlsInputsCheck] = useState();
const [previewUrlsInputsCheck, setPreviewUrlsInputsCheck] = useState();
const [layoutInfo, setLayoutInfo] = useState(false);
const [layoutArray, setLayoutArray] = useState([]);
const [isLayoutEdit, setIsLayoutEdit] = useState(false);
const [editLayoutIndex, setEditLayoutIndex] = useState(null);
const [editTargetLayout, setEditTargetLayout] = useState("");

const ResouceValues = {
    _id: "",
    church_id: "",
    resourceName: "",
    resourceDescription: "",
    categoryName: "",
    resourceUrl: "",
};
const [churchInputs, setChurchInputs] = useState(ResouceValues);
// 🔹 State for previous (existing) values when editing
const [previousChurchInputs, setPreviousChurchInputs] = useState({
    _id: "",
    church_name: "",
    church_description: "",
    church_address: "",
});

// 🔹 Validation errors
const [churchErrors, setChurchErrors] = useState({
    church_name: false,
    church_description: false,
    church_address: false,
});

// 🔹 Loader (renamed)
const [savingChurch, setSavingChurch] = useState(false);

// 🔹 Local store for churches (instead of DB)
const [churches, setChurches] = useState([]);
const [saveSuccess, setSaveSuccess] = useState(false);


const navigate = useNavigate();




const setShowNavigationAlert = (value) => {
    dispatch(setShowNavigationAlertAction(value));
};

const combineStateKeys = () => {
    const values = Object.values({
    video_title: videoInputs?.video_title,
    video_description: videoInputs?.video_description,
    });
    const combinedString = values.join("///");
    return combinedString;
};

const updateStateWithTranslation = () => {
    const combinedText = combineStateKeys();

    dispatch(
    translateLanguageAction({
        apiPayloadRequest: {
        targetcode: activeTab,
        translatetext: combinedText,
        },
        callback: (res) => {
        if (res?.type === 1) {
            onTranslateSuccess(res?.data);
        } else if (res?.type === 2) {
            Toastiy("Language Translation failed!!");
            Toastiy(res?.message);
        }
        },
    })
    );
};

const onTranslateSuccess = (data) => {
        const arrayOfValues = data.split("///");
    const arrayOfKeys = Object.keys({
    video_title: videoInputs?.video_title,
    video_description: videoInputs?.video_description,
    });

    for (let key in arrayOfKeys) {
    setVideoInputs((preState) => ({
        ...preState,
        [arrayOfKeys[key]]: arrayOfValues[key],
    }));
    }
    setShowNavigationAlert(true);
};

// const getRelatedVideos = (response) => {
//     if (response?.type === 1) {
//     response?.data?.map((item) =>
//         setOptions((prevData) => [
//         ...prevData,
//         {
//             value: item?._id || "",
//             label: item?.video_title || "",
//             image: item?.tumbnailurls?.length > 0 ? item?.tumbnailurls[0]?.url_link : "",
//         },
//         ])
//     );
//     } else {
//     Toastiy("Failed To Get Related Videos Data");
//     }
// };

const handleAddLayoutToArray = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        saveVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // expiry: layoutValues?.expiry,
            // title: layoutValues?.title,
            // subtitle: layoutValues?.subtitle,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Layout Added Successfully!", 1);
            setLayoutArray((prev) => [...prev, layoutValues]);
            setLayoutValues(initialLayoutValues);
            setAddedLayout(true);
            }
        },
        })
    );
    } else {
    setLayoutArray((prev) => [...prev, layoutValues]);
    setLayoutValues(initialLayoutValues);
    setAddedLayout(true);
    }
};

const handleDeleteLayoutFromArray = (id) => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        deleteVideoLayoutAction({
        apiPayloadRequest: {
            _id: id,
            videoObjId: videoInputs?._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            const updatedArray = layoutArray.filter((item) => item._id !== id);
            setLayoutArray(updatedArray);
            Toastiy("Layout Deleted Successfully!", 1);
            }
        },
        })
    );
    } else {
    const updatedArray = layoutArray.filter((item) => item._id !== id);
    setLayoutArray(updatedArray);
    }
};

const handleLayoutUpdate = () => {
    if (videoInputs?._id !== undefined && videoInputs?._id !== "") {
    dispatch(
        updateVideoLayoutAction({
        apiPayloadRequest: {
            _id: layoutValues?._id,
            videoObjId: videoInputs?._id,
            order: layoutValues?.order,
            // title: layoutArray._id,
            // subtitle: layoutArray._id,
            // expiry: layoutArray._id,
        },
        callback: (res) => {
            if (res?.type === 1) {
            setLayoutValues(initialLayoutValues);
            setIsLayoutEdit(false);
            Toastiy("Layout Updated Successfully!", 1);
            setShowNavigationAlert(false);
            }
        },
        })
    );
    } else {
    setLayoutValues(initialLayoutValues);
    setIsLayoutEdit(false);
    setShowNavigationAlert(true);
    }
};

const handleDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleVideoLayoutChange = (event) => {
    if (isLayoutEdit) {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));

    setLayoutArray((prev) => {
        const updatedArray = [...prev];

        updatedArray[editLayoutIndex] = {
        ...updatedArray[editLayoutIndex],
        [name]: value,
        };
        return updatedArray;
    });
    } else {
    const { name, value } = event.target;
    setLayoutValues((prev) => ({
        ...prev,
        [name]: value,
    }));
    setShowNavigationAlert(true);
    }
};

const handleVideoDateChange = (value) => {
    setLayoutValues((prev) => ({
    ...prev,
    expiry: value,
    }));
    setShowNavigationAlert(true);
};

const handleDropdownChange = (selectedValues) => {
                const videoItem = {
    value: selectedValues?._id,
    label: selectedValues?.video_title,
    image:
        selectedValues?.tumbnailurls?.length > 0 ? selectedValues?.tumbnailurls[0]?.url_link : "",
    order:
        selectedRelatedVideoIndex !== null
        ? selectedOptions[selectedRelatedVideoIndex]?.order
        : selectedOptions?.length + 1,
    };

    if (data?._id !== "" && data?._id !== undefined) {
    if (selectedRelatedVideoIndex !== null && selectedOptions[selectedRelatedVideoIndex]?.value) {
        dispatch(
        deleteVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: selectedOptions[selectedRelatedVideoIndex]?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                //show message
                dispatch(
                saveVideosrelatedAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    videoObjId: videoItem?.value,
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Related Video Updated Successfully!", 1);
                        setSelectedOptions((prev) =>
                        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
                        );
                    } else {
                        Toastiy("Failed to Update Video");
                    }
                    },
                })
                );
            }
            },
        })
        );
    } else {
        dispatch(
        saveVideosrelatedAction({
            apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoItem?.value,
            },
            callback: (res) => {
            if (res?.type === 1) {
                Toastiy("Related Video Added Successfully!", 1);
                setSelectedOptions((prev) => [...prev, videoItem]);
            } else {
                Toastiy("Failed to Add Video");
            }
            },
        })
        );
    }
    } else {
    if (selectedRelatedVideoIndex !== null) {
        setSelectedOptions((prev) =>
        prev?.map((d, i) => (i === selectedRelatedVideoIndex ? videoItem : d))
        );
    } else {
        setSelectedOptions((prev) => [...prev, videoItem]);
    }
    setShowNavigationAlert(true);
    }
    setShowVideoLibraryModal(false);
    setVideoErrors({ ...videoErrors, selectedOptions: false });
    setSelectedRelatedVideoIndex(null);
};

const deleteRelatedVideo = (videoObjId) => {
    if (data?._id) {
    dispatch(
        deleteVideosrelatedAction({
        apiPayloadRequest: {
            _id: data?._id,
            videoObjId: videoObjId,
        },
        callback: (res) => {
            if (res?.type === 1) {
            Toastiy("Related Video Removed Successfully!", 1);
            setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
            } else {
            Toastiy("Failed to Delete Video");
            }
        },
        })
    );
    } else {
    setSelectedOptions((prev) => prev.filter((item) => item.value !== videoObjId));
    }
    setSelectedRelatedVideoIndex(null);
};


const getAllLanguageResponse = (response) => {
    if (response?.type === 1) {
    setReadLanguageData(response?.data);
    setLoading(false);
    }
};

const handleInputChange = (event, setState) => {
    const { name, value } = event.target;
            setChurchInputs((prev) => ({
        ...prev,
        resourceUrl: value,   // 👈 directly update logo_url
      }));
    setVideoErrors({
    ...videoErrors,
    video_urls: false,
    video_download_urls: false,
    video_thumbnails_urls: false,
    video_common_thumbnails_urls: false,
    video_preview_urls: false,
    });
    setShowNavigationAlert(true);
};

const handleDownloadInputChange = (event) => {
    const { name, value } = event.target;
    setDownloadUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_download_urls: false });
    setShowNavigationAlert(true);
};

const handleTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setTumbNailUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleCommonTumbNailInputChange = (event) => {
    const { name, value } = event.target;
    setCommonUrlsInputs((prevData) => ({
    ...prevData,
    [name]: value,
    }));
    setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
    setShowNavigationAlert(true);
};

const handleChange = (event) => {
    const { name, value } = event.target;
        setChurchInputs((prevData) => ({
    ...prevData,
    [name]: value,
}));
setChurchErrors({ ...churchErrors, [name]: false });
setShowNavigationAlert(true);
};

const handleFileInputChange = (
    setState,
    keyName,
    file,
    type,
    uploadProgressId = null,
    downloadable = false,
    errorKeyName = ""
  ) => {
        setLoading(true);

    const formData = new FormData();
    formData.append("file", file);
    formData.append("downloadable", downloadable);


    // ✅ Directly call uploadAssestsV2Action with inline callback
    dispatch(
      uploadAssestsV2Action({
        apiPayloadRequest: formData,
        uploadProgressId,
        callback: (res) => {

          const uploadedUrl = res?.url || res?.data?.url || "";
          const uploadedFilename = res?.filename || res?.data?.filename || "";

          if (!uploadedUrl) {
                        toast.error("Upload failed: no URL returned from server.");
            setLoading(false);
            return;
          }

          // ✅ Update main form state
          setChurchInputs((prev) => {
            const updated = { ...prev, resourceUrl: uploadedUrl };
                        return updated;
          });

          // ✅ Update thumbnail input dynamically
          setTumbNailUrlsInputs((prev) => ({
            ...prev,
            [keyName]: uploadedUrl,
          }));

          // ✅ Reset errors and flags
        //   setVideoErrors((prev) => ({ ...prev, [errorKeyName]: false }));
        //   setLoading(false);
        //   setShowNavigationAlert(true);
        },
      })
    );
  };





const handleFileDownloadInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setDownloadUrl(res?.url);
        setDownloadUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_download_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setDownloadValues(value);
};

const handleFiletumbNailInputChange = (language, field, file, value) => {
    const formData = new FormData();
    formData.append("file", file);
    dispatch(
    uploadAssestsAction({
        apiPayloadRequest: formData,
        callback: (res) => {
        setThumbNailUrl(res?.url);
        setTumbNailUrlsInputs((prevInputs) => ({
            ...prevInputs,
            [field]: res?.url,
        }));
        setVideoErrors({ ...videoErrors, video_thumbnails_urls: false });
        setShowNavigationAlert(true);
        },
    })
    );
    setThumbNailValues(value);
};

const handleRelatedVideosChange = (selectedOptions) => {
    setInputs((prevInputs) => ({
    ...prevInputs,
    [activeTab]: {
        ...prevInputs[activeTab],
        relatedVideos: selectedOptions.map((option) => option.value),
    },
    }));
    setShowNavigationAlert(true);
    // setVideoErrors({ ...videoErrors, selectedOptions: false });
};

const handleVideoDescriptionChange = (e) => {
    handleInputChange(activeTab, "videoDescription", e.target.value);
    setShowNavigationAlert(true);
};

const videoData =
    videoUrlsInputs.mobileUploadUrl !== ""
    ? videoUrlsInputs.mobileUploadUrl
    : videoUrlsInputs.webUploadUrl !== ""
    ? videoUrlsInputs.webUploadUrl
    : videoUrlsInputs.tabletUploadUrl;

const downloadData =
    UdownloadrlsInputs.mobileUploadUrl !== ""
    ? UdownloadrlsInputs.mobileUploadUrl
    : UdownloadrlsInputs.webUploadUrl !== ""
    ? UdownloadrlsInputs.webUploadUrl
    : UdownloadrlsInputs.tabletUploadUrl;

const tumbNailData =
    tumbNailUrlsInputs.mobileUploadUrl !== ""
    ? tumbNailUrlsInputs.mobileUploadUrl
    : tumbNailUrlsInputs.webUploadUrl !== ""
    ? tumbNailUrlsInputs.webUploadUrl
    : tumbNailUrlsInputs.tabletUploadUrl;


    const handleSave = async (resourceId, churchId) => {

        if (typeof setSavingChurch === "function") setSavingChurch(true);

        const payload = {
          _id: churchId || "",
          resourceName: churchInputs?.resourceName?.trim() || "",
          resourceDescription: churchInputs?.resourceDescription?.trim() || "",
          categoryName: churchInputs?.categoryName?.trim() || "",
          resourceUrl:
            churchInputs?.resourceUrl?.trim() ||
            tumbNailUrlsInputs?.webUploadUrl ||
            "",
        };

        return new Promise((resolve, reject) => {
          const callback = async (res) => {
            if (typeof setSavingChurch === "function") setSavingChurch(false);

            if (res?.type === 1) {
              toast.success("Resource added successfully!");
              setVideoInputs({});

              // ------------------------------------------------------
              // ✅ NOW CALL SAVE RESOURCE VIDEO API
              // ------------------------------------------------------

              const resourceObjId = res?.data?.resourceObjId;
            //   if(thumbnailImage){
            //   await saveResourceVideoAfterResourceSave(churchId, resourceObjId);
            //   }
              resolve(res);
            } else {
              toast.error(res?.error || "Failed to save resource.");
              reject(res);
            }
          };


          dispatch(saveResourceRequest(payload, callback));
        });
      };


      const saveResourceVideoAfterResourceSave = async (churchId, resourceObjId) => {

        const videoPayload = {
          _id: churchId,                  // Church ID
          resourceObjId: resourceObjId,   // Resource ID from first API
          videoObjId: thumbnailImage || "", // THUMBNAIL IMAGE ID
          default: isDefault ? true: false,     // BOOLEAN → INT
          live: isLive ? true : false,           // BOOLEAN → INT
        };


        return new Promise((resolve, reject) => {
          const callback = (res) => {

            if (res?.type === 1) {
              toast.success("Resource Video added!");
              resolve(res);
            } else {
              toast.error(res?.error || "Failed to save resource video.");
              reject(res);
            }
          };

          dispatch(saveResourceVideoRequest(videoPayload, callback));
        });
      };

      const handleUpdateChurch = (rowData) => {
        return new Promise((resolve, reject) => {
                               if (typeof setSavingChurch === "function") setSavingChurch(true);

          // ✅ Prepare payload (backend expects both _id and resourceObjId)
          const payload = {
            _id: rowData.churchId || "", // Church ID
            resourceObjId: rowData.resourceObjId || "", // Resource ID (required)
            resourceName: churchInputs?.resourceName?.trim() || rowData.resourceName || "",
            resourceDescription:
              churchInputs?.resourceDescription?.trim() || rowData.resourceDescription || "",
            categoryName: churchInputs?.categoryName?.trim() || rowData.categoryName || "",
            resourceUrl: churchInputs?.resourceUrl?.trim() || rowData.resourceUrl || "",
          };

          // ✅ Define callback (same pattern as handleSave)
          const callback = (res) => {
            if (typeof setSavingChurch === "function") setSavingChurch(false);

            if (res?.type === 1) {
              toast.success("Resource updated successfully!");
              resolve(res); // ✅ resolve on success
            } else {
              toast.error(res?.error || "Failed to update resource.");
              reject(res); // ❌ reject on failure
            }
          };


          // ✅ Dispatch using new action format (callback passed separately)
          dispatch(updateResourceRequest(payload, callback));
        });
      };




const fetchVideoDetails = () => {
    dispatch(
    readVideosAction({
        apiPayloadRequest: {
        _id: data?._id,
        },
        callback: (res) => {
        const data = res?.data[0];
        // setVideoInputs({
        //   _id: data?._id,
        //   video_title: data?.video_title || "",
        //   video_description: data?.video_description || "",
        // });

        setCurrentInputs({
            _id: data?._id,
            video_title: data?.video_title || "",
            video_description: data?.video_description || "",
            totalLikes: data?.totallikes || 0,
            totalViews: data?.video_views || 0,
        });

        setLanguagemeta(data?.languagemetas);

        setVideoUrlsInputsCheck({
            mobileUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl: data?.urls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.urls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });


        setDownloadUrlsInputsCheck({
            mobileUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.downloadurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setTumbNailUrlsInputsCheck({
            mobileUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.tumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        setCommonUrlsInputsCheck({
            mobileUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "0")[0].url_link ||
            "",
            webUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "1")[0].url_link ||
            "",
            tabletUploadUrl:
            data?.gnerictumbnailurls?.filter((item) => item.type_of_url === "2")[0].url_link ||
            "",
        });

        setPreviewUrlsInputsCheck({
            mobileUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "0")[0].url_link || "",
            webUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "1")[0].url_link || "",
            tabletUploadUrl:
            data?.trailers?.filter((item) => item.type_of_url === "2")[0].url_link || "",
        });

        // const isValidRelatedVideos = data?.relatedvideos?.find((v) => v?.videoObjId?.length > 0);
        // const relatedVideos = isValidRelatedVideos ? data?.relatedvideos : [];
        const relatedVideos = data?.relatedvideos ?? [];
        const relatedVideosList = [];
        relatedVideos.map((item) => {
            relatedVideosList.push({
            value: item?.videoObjId?._id,
            label: item?.videoObjId?.video_title,
            image: item?.videoObjId?.tumbnailurls[0].url_link,
            });
        });
        setSelectedOptions(relatedVideosList);
        },
    })
    );
};


const [isLanguageSave, setIsLanguageSave] = useState(true);
const [currentLanguageInputs, setCurrentLanguageInputs] = useState();
const [currentLanguageUrlCheck, setCurrentLanguageUrlCheck] = useState();
const [currentLanguageDownloadUrlCheck, setCurrentLanguageDownloadUrlCheck] = useState();
const [currentLanguagePreviewUrlCheck, setCurrentLanguagePreviewUrlCheck] = useState();





const handleSaveLanguage = async () => {
    const requestsList = [];
    if (isLanguageSave) {
    const keysArray = Object.keys(videoUrlsInputs);

    requestsList.push(
        new Promise((resolve, reject) => {
        dispatch(
            saveVideoLanguageAction({
            apiPayloadRequest: {
                _id: data?._id,
                language_code: activeTab,
                video_title: videoInputs?.video_title,
                video_description: videoInputs?.video_description,
            },
            callback: (res) => {
                if (res?.type === 1) {
                Toastiy("Video Language Saved Successfully", 1);
                setShowNavigationAlert(false);
                }
                resolve();
            },
            })
        );
        })
    );

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (videoUrlsInputs[item]) {
                dispatch(
                saveVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 500);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (UdownloadrlsInputs[item]) {
                dispatch(
                saveDownloadVideoUrlLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Download URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 600);
        })
        );
    });

    keysArray.map((item, index) => {
        requestsList.push(
        new Promise((resolve, reject) => {
            setTimeout(() => {
            if (previewUrlsInputs[item]) {
                dispatch(
                saveVideoPreviewLanguageAction({
                    apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                    },
                    callback: (res) => {
                    if (res?.type === 1) {
                        Toastiy("Video Preview URLs Saved Successfully", 1);
                        setShowNavigationAlert(false);
                    }
                    resolve();
                    },
                })
                );
            } else {
                resolve();
            }
            }, (index + 1) * 650);
        })
        );
    });
    } else {
    const keysArray = Object.keys(videoUrlsInputs);

    if (
        videoInputs?.video_title !== currentLanguageInputs?.video_title ||
        videoInputs?.video_description !== currentLanguageInputs?.video_description
    ) {
        requestsList.push(
        new Promise((resolve, reject) => {
            dispatch(
            updateVideoLanguageAction({
                apiPayloadRequest: {
                _id: data?._id,
                language_code: activeTab,
                video_title: videoInputs?.video_title,
                video_description: videoInputs?.video_description,
                },
                callback: (res) => {
                if (res?.type === 1) {
                    Toastiy("Video Language Updated Successfully", 1);
                    setShowNavigationAlert(false);
                }
                resolve();
                },
            })
            );
        })
        );
    }

    keysArray.map((item) => {
        if (!currentLanguageUrlCheck[item] && videoUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        videoUrlsInputs[item] &&
        videoUrlsInputs[item] !== currentLanguageUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: videoUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguageDownloadUrlCheck[item] && UdownloadrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        UdownloadrlsInputs[item] &&
        UdownloadrlsInputs[item] !== currentLanguageDownloadUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateDownloadVideoUrlLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: UdownloadrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Download URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });

    keysArray.map((item) => {
        if (!currentLanguagePreviewUrlCheck[item] && previewUrlsInputs[item]) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                saveVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        } else if (
        previewUrlsInputs[item] &&
        previewUrlsInputs[item] !== currentLanguagePreviewUrlCheck[item]
        ) {
        requestsList.push(
            new Promise((resolve, reject) => {
            dispatch(
                updateVideoPreviewLanguageAction({
                apiPayloadRequest: {
                    _id: data?._id,
                    language_code: activeTab,
                    type_of_url: item === "mobileUploadUrl" ? 0 : item === "webUploadUrl" ? 1 : 2,
                    url_link: previewUrlsInputs[item],
                },
                callback: (res) => {
                    if (res?.type === 1) {
                    Toastiy("Video Preview URLs Updated Successfully", 1);
                    setShowNavigationAlert(false);
                    }
                    resolve();
                },
                })
            );
            })
        );
        }
    });
    }

    await Promise.all(requestsList);
    fetchVideoDetails();
};

const handleLibraryVideoSelection = (details) => {
        setVideoInputs((prev) => ({
    ...prev,
    video_title: details?.video_title,
    video_description: details?.video_description,
    }));
    setVideoUrlsInputs({
    mobileUploadUrl: details?.urls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.urls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.urls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setDownloadUrlsInputs({
    mobileUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.downloadurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setTumbNailUrlsInputs({
    mobileUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.tumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setCommonUrlsInputs({
    mobileUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "0")?.url_link,
    webUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "1")?.url_link,
    tabletUploadUrl: details?.gnerictumbnailurls?.find((d) => d?.type_of_url === "2")?.url_link,
    });
    setShowNavigationAlert(true);
};

const handleSendNotification = () => {
    dispatch(
    sendCustomNotificationAction({
        apiPayloadRequest: {
        _id: data?._id,
        type: "2",
        },
        callback: (res) => {
        if (res?.type === 1) {
            Toastiy("Notification Sent Successfully", 1);
        }
        },
    })
    );
};

return {
    value,
    onChangeSearchBar,
    languages,
    activeTab,
    setActiveTab,
    activeLanguageDetails,
    setActiveLanguageDetails,
    inputs,
    handleInputChange,
    handleFileInputChange,
    handleRelatedVideosChange,
    handleVideoDescriptionChange,
    handleSave,
    readLanguageData,
    videoInputs,
    videoErrors,
    showVideoLibraryModal,
    setShowVideoLibraryModal,
    setVideoUrlsInputs,
    setDownloadUrlsInputs,
    setTumbNailUrlsInputs,
    videoUrlsInputs,
    handleFileDownloadInputChange,
    handleFiletumbNailInputChange,
    tumbNailUrlsInputs,
    UdownloadrlsInputs,
    handleChange,
    handleTumbNailInputChange,
    handleDownloadInputChange,
    selectedOptions,
    setSelectedOptions,
    deleteRelatedVideo,
    setSelectedRelatedVideoIndex,
    handleDropdownChange,
    setLayoutValues,
    handleVideoLayoutChange,
    layoutValues,
    initialLayoutValues,
    setLayoutInfo,
    layoutInfo,
    handleDateChange,
    handleAddLayoutToArray,
    layoutArray,
    setAddedLayout,
    addedLayout,
    handleVideoDateChange,
    options,
    handleDeleteLayoutFromArray,
    setIsLayoutEdit,
    setEditLayoutIndex,
    isLayoutEdit,
    handleLayoutUpdate,
    setEditTargetLayout,
    editTargetLayout,
    updateStateWithTranslation,
    handleCommonTumbNailInputChange,
    setCommonUrlsInputs,
    commonVideoUrlsInputs,
    previewUrlsInputs,
    setPreviewUrlsInputs,
    languagemeta,
    setIsLanguageSave,
    handleSaveLanguage,
    handleLibraryVideoSelection,
    currentInputs,
    handleSendNotification,
    churchInputs, // instead of videoInputs
    churchErrors, // instead of videoErrors
    handleChange,
    handleSave,
    handleUpdateChurch,
    setImageSet,
    setChurchInputs,
    churchInputs,
    thumbnailImage, setThumbnailImage,
    isLive,setIslive,
    isDefault,setIsDefault
};
};
